<template>
  <div class="root">
    <label v-if="label" class="is-size-4 label">{{ label }}</label>
    <div style="margin: 8px">
      <display-key-value v-for="item in items" :key="item.label"
        :label="item.label"
        :text="item.text"
        :width="width"
      />
    </div>
  </div>
</template>

<script>
import DisplayKeyValue from "@/components/molecules/DisplayKeyValue/index.vue";

export default {
  components: { DisplayKeyValue },
  props: {
    label: String,
    items: Array,
    width: String,
  },
};
</script>


<style lang="scss" scoped>
.root {
  display: flex;
  flex-direction: column;
}
.label {
  border-bottom: solid 2px #363637;
  color: #363637;
}
</style>

